var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$tcw.$store.errors.hasError)?[_c('error-info-page')]:(!_vm.$store.getters['SessionStoreModule/has'])?[_c('login')]:[_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }